import {React, useEffect} from 'react';
import {
    FaUser
  } from "react-icons/fa";
import profilePicture from "../assets/portfolio_pic.png";
import { Link } from "react-router-dom";
import { Typewriter } from 'react-simple-typewriter';


function Home() {

    useEffect(() => {
        window.scrollTo(0, 0)
      }, []);

  return (
    <>
    {/* home section starts */}
    <section className="home">
      <div className='fullImageBox'>
      <div className="image cursorPointer">
      
      <div className='imgContent'>
      <img src={profilePicture} alt="profilePicture" loading='lazy'/>
          <h2> SUREKA GK<br/><span> Full-Stack Developer </span> </h2>
          <Link to="/contact"> Contact me </Link>
      </div>
    </div>

      </div>
    
    <div className="content">
      <h3> Hi, I Am SUREKA </h3>
      <span> <Typewriter
            words={['Full-Stack Developer']}
            loop={0}
            cursor
            // cursorStyle='_'
            typeSpeed={100}
            deleteSpeed={80}
            delaySpeed={1000}
          /> </span>
      
          <p> Software Developer with a Bachelor of Computer Applications from SASTRA University.
            Proficient in Java, C, C++, Python, SQL, HTML, CSS, and JavaScript with strong problem-solving skills.
            Experienced in web development using Flask, MySQL, and Bootstrap to build responsive and user-friendly applications.
            Developed a Personal Expense Tracker with features like user authentication, expense tracking, budget alerts via email,
            PDF report export, and visual analytics using Chart.js.
            Built a responsive E-Commerce website with custom theme design, payment gateway, and basic content management features.
            Skilled in using GitHub, Postman, MS Office, and Excel for project management and documentation.
            Certified in PostgreSQL, Full Stack Java Development, and Diploma in Computer Applications.
            Passionate about learning new technologies, creating innovative solutions, and growing as a dedicated software professional.</p>
      <div className="aboutMeBtn">
      <Link to="/about" className='textNone'>
      <div className="btn"> About Me <span> <FaUser className="userBtnIcon"/> </span> </div>
      </Link>
      </div>
    </div>
  </section>
  {/* home section ends */}
  </>
  )
}

export default Home